export let pinTitle = "HtDADb";
export let settingsTitle = "D0Rxtb";
export default {pinTitle,settingsTitle};